import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Programs from "@/components/Programs";
import Footer from "@/components/Footer";
import { SEOHead, organizationSchema } from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="Summer Camps & After School in Phoenix"
        description="Register for kids programs at MSB Camps in Phoenix: after-school care, summer & holiday camps, and clubs for ages 4-14. Enroll today."
        canonicalUrl="https://msbcamps.com/"
        structuredData={organizationSchema}
      />
      <Header />
      <main>
        <Hero />
        <Programs />
      </main>
      <Footer />
    </div>
  );
};

export default Index;